import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import Delete_iconbl from "../../../assets/images/icons/delete_iconbl.svg";
import { useTranslation } from "react-i18next";
import { NotificationManager } from "react-notifications";
import { MinMaxMarkupPrice, MinMaxSize } from "../../../helper/commanData";
import AdminManageCurrencyService from "../../../services/admin-manageCurrency.service";
import { setCurrency } from "../../../actions/login/login";
import { type } from "@testing-library/user-event/dist/type";
import { Button, Checkbox, Modal, Select, Spin, Table, Tooltip } from "antd";
import  AppsColorStoneLinksService from "../../../services/apps-colorstonelinks.service";

const { Option } = Select;

const GemStoneMarkup = (props) => {
  const type = props.type;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isButtonDisable, setIsButtonDisable] = useState(true);
  const [makerLoading, setMakerLoading] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [DealerId, setDealerId] = useState();
  const [delMarkupData, setDelMarkupData] = useState({
    dealermarkupid: "",
    dealerID: "",
  });
  const [DelCutomerMarkupData, setDelCutomerMarkupData] = useState({
    dealerID: "",
    customMarkupid: "",
  });
  const [isedit, setIsEdit] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visible1, setVisible1] = useState(false);
  const [costPriceAndSize, setCostPriceAndSize] = useState({});
  const [page, setPage] = useState("");
  const [manufactureList, setmanufactureList] = useState([]);
  const [minMaxMarkupPrice] = useState(MinMaxMarkupPrice);
  const [minMaxSize] = useState(MinMaxSize);
  const [checkbox, setCheckBox] = useState("");
  const [GemstoneData, setGemstoneData] = useState({
    CustomInput1: "",
    CustomInput2: "",
    CustomInput3: "",
    Method: "",
    Currency: null,
    CustomMethod: null,
    DefaultMarkup: "",
    SelectManufacturer: null,
    MarkupPercent: null,
    custommarkupid: 0,
    CertCl: "",
    CertClValue: "",
    CertClPercent: "",
    DefaultMarkupOld: 0,
    GIA: false,
    AGS: false,
    EGL: false,
    IGI: false,
    Currency: null,
  });
  const category = [
    {
      label: "GIA",
      value: "GIA",
    },
    {
      label: "AGS",
      value: "AGS",
    },
    {
      label: "IGI",
      value: "IGI",
    },
    {
      label: "EGL",
      value: "EGL",
    },
  ];
  const [markedUpDealersList, setMarkedUpDealersList] = useState([]);
  const [customMarkUpsList, setCustomMarkUpsList] = useState([]);
  const currency = useSelector((state) => state.loginReducer.currency);
  const currencySymbol = currency?.substring(currency.lastIndexOf("-") + 1);

  const [validations, setValidations] = useState({
    MarkupPercentVal: "",
    SelectManufacturerVal: "",
  });
  const [validations1, setValidations1] = useState({
    CertClVal: "",
    CertClValueVal: "",
    CertClPercentVal: "",
  });
  const [defaultMarkupValidation, setDefaultMarkupValidation] = useState({
    DefaultMarkupVal: "",
  });
  const [selectCurrencyDropdowenList, setSelectCurrencyDropdowenList] =
    useState([]);
  const [getAllCostPriceAndSizeLoading, setGetAllCostPriceAndSizeLoading] =
    useState(false);
  const loginDetials = useSelector((state) => state.loginReducer);
  const [showAllComponent, setShowAllComponent] = useState(true);

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleGetMineMarkupLoadData(
            loginDetials.loginDetials.responseData.dealerId,
            type
          );
        }
      }
      handleGetSelectCurrencyDropdowen();
    }
  }, [type]);

  const handleGetSelectCurrencyDropdowen = () => {
    try {
      AdminManageCurrencyService.GetSelectCurrencyDropdowen()
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setSelectCurrencyDropdowenList(responseData);
            } else {
              setSelectCurrencyDropdowenList([]);
            }
          } else {
            setSelectCurrencyDropdowenList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleDefaultMarkupValidation = () => {
    const { DefaultMarkup } = GemstoneData;
    const defaultMarkupValidation = {
      DefaultMarkupVal: "",
    };
    let isValid = true;

    if (!DefaultMarkup) {
      isValid = false;
      defaultMarkupValidation.DefaultMarkupVal = t(
        "Please Select Default Markup"
      );
    } else if (DefaultMarkup.includes("-")) {
      isValid = false;
      defaultMarkupValidation.DefaultMarkupVal = t(
        "Negative Values is not Accepted"
      );
    } else {
      defaultMarkupValidation.DefaultMarkupVal = "";
    }
    setDefaultMarkupValidation(defaultMarkupValidation);
    return isValid;
  };

  const handleValidation = () => {
    const { SelectManufacturer, MarkupPercent } = GemstoneData;

    const validations = {
      MarkupPercentVal: "",
      SelectManufacturerVal: "",
    };

    let isValid = true;

    if (!SelectManufacturer) {
      isValid = false;
      validations.SelectManufacturerVal = t("Please Select Manufacturer");
    } else {
      validations.SelectManufacturerVal = "";
    }

    if (!MarkupPercent) {
      isValid = false;
      validations.MarkupPercentVal = t("Please select markup");
    } else {
      validations.MarkupPercentVal = "";
    }

    setValidations(validations);
    return isValid;
  };

  const handleValidation1 = () => {
    const {
      CertCl,
      CertClValue,
      CertClPercent,
      CustomInput1,
      CustomInput2,
      CustomInput3,
      CustomMethod,
    } = GemstoneData;

    const validations1 = {
      CertClVal: "",
      CertClValueVal: "",
      CertClPercentVal: "",
      CustomInput1Val: "",
      CustomInput2Val: "",
      CustomInput3Val: "",
    };

    let isValid = true;

    if (CustomMethod === "2") {
      if (!CustomInput1) {
        isValid = false;
        validations1.CustomInput1Val = t("Please Enter Min Range");
      } else if (CustomInput1.length > 10) {
        isValid = false;
        validations1.CustomInput1Val = t(
          "Min Range should be less than 10 digit"
        );
      } else {
        validations1.CustomInput1Val = "";
      }

      if (!CustomInput2) {
        isValid = false;
        validations1.CustomInput2Val = t("Please Enter Max Range");
      } else if (CustomInput2.length > 10) {
        isValid = false;
        validations1.CustomInput2Val = t(
          "Max Range should be less than 10 digit"
        );
      } else if (Number(CustomInput2) < Number(CustomInput1)) {
        isValid = false;
        validations1.CustomInput2Val = t(
          "Max Price should be greater than Min Price"
        );
      } else {
        validations1.CustomInput2Val = "";
      }

      if (!CustomInput3) {
        isValid = false;
        validations1.CustomInput3Val = t("Please Enter Markup");
      } else {
        validations1.CustomInput3Val = "";
      }
    } else {
      if (!CertCl) {
        isValid = false;
        validations1.CertClVal = t("Please Enter Min Range");
      } else if (CertCl.length > 10) {
        isValid = false;
        validations1.CertClVal = t("Min Range should be less than 10 digit");
      } else {
        validations1.CertClVal = "";
      }

      if (!CertClValue) {
        isValid = false;
        validations1.CertClValueVal = t("Please Enter Max Range");
      } else if (CertClValue.length > 10) {
        isValid = false;
        validations1.CertClValueVal = t(
          "Max Range should be less than 10 digit"
        );
      } else if (Number(CertClValue) < Number(CertCl)) {
        isValid = false;
        validations1.CertClValueVal = t(
          "Max Price should be greater than Min Price"
        );
      } else {
        validations1.CertClValueVal = "";
      }

      if (!CertClPercent) {
        isValid = false;
        validations1.CertClPercentVal = t("Please Enter Markup");
      } else {
        validations1.CertClPercentVal = "";
      }
    }

    setValidations1(validations1);
    return isValid;
  };

  const handleOnChange = (e, isSelect, name) => {
    setIsButtonDisable(false);
    if (isSelect === "select") {
      setGemstoneData({
        ...GemstoneData,
        [name]: e,
      });

      if (name === "Currency") {
        setGemstoneData({
          ...GemstoneData,
          [name]: e,
        });
      }
      if (name == "CustomMethod") {
        handleGetCustomerMineMarkupLoadData(DealerId, e, props.type);
      }

      if (e == "Custom" || e == "Price" || e == "Size") {
        setPage(e);
        handleGetAllCostPriceAndSize(DealerId, e);
      }
      if (name === "SelectManufacturer") {
        setValidations((prevdata) => ({
          ...prevdata,
          SelectManufacturerVal: "",
        }));
      }
      if (e !== "Custom") {
        setDefaultMarkupValidation({
          DefaultMarkupVal: "",
        });
      }
    } else {
      if (e.target.name == "DefaultMarkup") {
        setGemstoneData({
          ...GemstoneData,
          [e.target.name]: e.target.value,
        });
      } else if (e.target.name == "CertClPercent") {
        if (e.target.value.split(".")[1]) {
          if (e.target.value.split(".")[1].length <= 2) {
            setGemstoneData({
              ...GemstoneData,
              [e.target.name]:
                Number(e.target.value) >= 0
                  ? e.target.value
                  : GemstoneData.CertClPercent,
            });
          } else {
            setGemstoneData({
              ...GemstoneData,
              [e.target.name]: GemstoneData.CertClPercent,
            });
          }
        } else {
          setGemstoneData({
            ...GemstoneData,
            [e.target.name]:
              Number(e.target.value) >= 0
                ? e.target.value
                : GemstoneData.CertClPercent,
          });
        }
      } else if (e.target.name === "MarkupPercent") {
        if (e.target.value.split(".")[1]) {
          if (e.target.value.split(".")[1].length <= 2) {
            setGemstoneData({
              ...GemstoneData,
              [e.target.name]:
                Number(e.target.value) >= 0
                  ? e.target.value
                  : GemstoneData.MarkupPercent,
            });
          } else {
            setGemstoneData({
              ...GemstoneData,
              [e.target.name]: GemstoneData.MarkupPercent,
            });
          }
        } else {
          setGemstoneData({
            ...GemstoneData,
            [e.target.name]:
              Number(e.target.value) >= 0
                ? e.target.value
                : GemstoneData.MarkupPercent,
          });
        }
      } else {
        setGemstoneData({
          ...GemstoneData,
          [e.target.name]: e.target.value,
        });
      }

      if (e.target.name === "MarkupPercent") {
        setValidations((prevdata) => ({
          ...prevdata,
          MarkupPercentVal: "",
        }));
      }
      if (e.target.name == "CertCl") {
        setValidations1((prevdata) => ({
          ...prevdata,
          CertClVal: "",
        }));
      }
      if (e.target.name == "CertClValue") {
        setValidations1((prevdata) => ({
          ...prevdata,
          CertClValueVal: "",
        }));
      }
      if (e.target.name == "CertClPercent") {
        setValidations1((prevdata) => ({
          ...prevdata,
          CertClPercentVal: "",
        }));
      }
    }
  };
  const handleOnChangeRadio = (event, name) => {
    let tempObj = {
      GIA: false,
      AGS: false,
      EGL: false,
      IGI: false,
    };
    tempObj[name] = event.target.checked;
    setGemstoneData({
      ...GemstoneData,
      ...tempObj,
    });
  };

  // For Table Data Price and Size

  const handleTableOnchange = (e) => {
    const { name, value } = e.target;
    const tempcostPriceAndSize = costPriceAndSize;

    tempcostPriceAndSize[name] = value;
    setCostPriceAndSize({ ...tempcostPriceAndSize });
    setIsButtonDisable(false);
  };

  // Get All Data

  const handleGetMineMarkupLoadData = (id, type) => {
    let inputData = {
      dealerID: id,
    };
    try {
      AppsColorStoneLinksService.GetMarkupLoadData(inputData, type)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setPage(
                responseData.markUpMethod == null
                  ? "Price"
                  : responseData.markUpMethod == "custom"
                  ? "Custom"
                  : responseData.markUpMethod == "price"
                  ? "Price"
                  : responseData.markUpMethod == "size"
                  ? "Size"
                  : responseData.markUpMethod
              );
              setmanufactureList(responseData.ddlManufacturerList);
              setGemstoneData((prevdata) => ({
                ...prevdata,
                Method:
                  responseData.markUpMethod == null
                    ? "Price"
                    : responseData.markUpMethod,
                CustomMethod: responseData.customMarkupMethod.toString(),
                DefaultMarkup: responseData.currentMarkup,
                Currency: Number(responseData.drp_Currency),
                DefaultMarkupOld: responseData.currentMarkup,
              }));
              handleGetMakerMineMarkupLoadData(id, type);

              handleGetCustomerMineMarkupLoadData(
                id,
                convertCustMethodToNumber(responseData.customMarkupMethod),
                type
              );
              if (
                responseData.markUpMethod.toLowerCase() == "price" ||
                responseData.markUpMethod.toLowerCase() == "size"
              ) {
                handleGetAllCostPriceAndSize(id, responseData.markUpMethod);
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetMakerMineMarkupLoadData = (id, type) => {
    let inputData = {
      dealerID: id,
    };
    setMakerLoading(true);
    try {
      AppsColorStoneLinksService.GetMakerGemStoneMarkupLoadData(inputData, type)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setMakerLoading(false);
              setMarkedUpDealersList(responseData.getMakeromMarkUpsLst);
              setShowAllComponent(false);
            }
          } else {
            setMakerLoading(false);
            setMarkedUpDealersList([]);
            setShowAllComponent(false);
          }
        })
        .catch((error) => {
          setMakerLoading(false);
          setShowAllComponent(false);
          console.log(error);
        });
    } catch (error) {
      setMakerLoading(false);
      setShowAllComponent(false);
      console.log(error);
    }
  };

  const convertCustMethodToNumber = (method) => {
    if (method === null || method === undefined) return 0;
    // If already a number, return it
    if (typeof method === 'number') return method;
    // If it's a numeric string, convert directly
    const num = Number(method);
    if (!isNaN(num)) return num;
    // Convert text values to numbers
    const methodLower = method.toString().toLowerCase();
    if (methodLower === 'size' || methodLower === 'by size') return 1;
    if (methodLower === 'price' || methodLower === 'by price') return 0;
    if (methodLower === 'off%' || methodLower === 'by off%') return 2;
    return 0; // default
  };

  const handleGetCustomerMineMarkupLoadData = (id, custMethod, type) => {
    let inputData = {
      dealerID: id,
      custMethod: convertCustMethodToNumber(custMethod),
    };
    setCustomerLoading(true);
    try {
      AppsColorStoneLinksService.GetCustomerGemStoneMarkupLoadData(inputData, type)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;

          if (message === "Success" && responseData) {
            let data = responseData.getCustomMarkUpsLst || [];

            if (custMethod === "2" || custMethod === 2) {
              data = data.map((item) => ({
                ...item,
                CustomInput1Val: parseFloat(item.minrange),
                CustomInput2Val: parseFloat(item.maxrange),
                CustomInput3Val: parseFloat(item.markup),
              }));
            }

            setCustomerLoading(false);
            setCustomMarkUpsList(data);
            setShowAllComponent(false);
          } else {
            setCustomerLoading(false);
            setCustomMarkUpsList([]);
            setShowAllComponent(false);
          }
        })
        .catch((error) => {
          setCustomerLoading(false);
          setShowAllComponent(false);
          console.log(error);
        });
    } catch (error) {
      setCustomerLoading(false);
      setShowAllComponent(false);
      console.log(error);
    }
  };

  const handleCancel = () => {
    setVisible(false);
  };
  const handleCancel1 = () => {
    setVisible1(false);
  };

  const handleDeleteData = (row) => {
    setVisible(true);
    setDelMarkupData({
      dealermarkupid: row.dealermarkupid,
      dealerID: row.dealerid,
    });
  };

  const handleDeleteCustomerMarkupData = (row) => {
    setIsButtonDisable(false);
    setVisible1(true);
    setDelCutomerMarkupData({
      customMarkupid: row.custommarkupid,
      dealerID: DealerId,
    });
  };

  const handleAddDealerMarkupdata = () => {
    let isValid = handleValidation();
    if (!isValid) {
      return false;
    }
    try {
      let inputData = {
        dealerID: DealerId,
        ddlManufacturerId: GemstoneData.SelectManufacturer,
        dealerMarkup: GemstoneData.MarkupPercent,
      };
      AppsColorStoneLinksService.SaveGemStoneDealerMarkupdata(inputData, props.type)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          let msg = responseData.returnMessage;

          if (message === "Success") {
            if (msg == "Markup Already Exists For Selected Manufacturer") {
              NotificationManager.success(
                t("Markup Already Exists For Selected Manufacturer")
              );
            } else {
              NotificationManager.success(
                t("Manufacturer Markup Saved Successfully")
              );
              handleGetMakerMineMarkupLoadData(DealerId, props.type);
            }
          } else {
            NotificationManager.error(t("Manufacturer Markup Not Saved"));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
    setVisible(false);
    setDelMarkupData({});
    setGemstoneData({
      ...GemstoneData,
      SelectManufacturer: "",
      MarkupPercent: "",
    });
  };

  // Add SaveMIneCustomMarkupdata

  const handleSaveCustomMarkupdata = () => {
    let isValid1 = handleValidation1();
    if (!isValid1) {
      return false;
    }

    try {
      const isOffRange = GemstoneData.CustomMethod === "2";

      let inputData = {
        customMarkupID: GemstoneData.custommarkupid
          ? GemstoneData.custommarkupid
          : 0,
        minrange: isOffRange
          ? GemstoneData.CustomInput1
          : GemstoneData.CertCl,
        maxrange: isOffRange
          ? GemstoneData.CustomInput2
          : GemstoneData.CertClValue,
        markup: isOffRange
          ? GemstoneData.CustomInput3
          : GemstoneData.CertClPercent,
        dealerId: DealerId,
        certificate: "",
        customMethod: GemstoneData.CustomMethod,
        chkGIA: isedit ? checkbox.includes("GIA") : GemstoneData.GIA,
        chkAGS: isedit ? checkbox.includes("AGS") : GemstoneData.AGS,
        chkEGL: isedit ? checkbox.includes("EGL") : GemstoneData.EGL,
        chkIGI: isedit ? checkbox.includes("IGI") : GemstoneData.IGI,
        hdnSaveeditval: "",
      };
      if (GemstoneData.CustomMethod === "2") {
        console.log(
          "CustomMethod == 2 inputs:",
          GemstoneData.CustomInput1,
          GemstoneData.CustomInput2,
          GemstoneData.CustomInput3
        );
        console.log(
          "Logging GemstoneData just before API call:",
          GemstoneData
        );
      } else {
        console.log(
          "CustomMethod is not 2, it's:",
          GemstoneData.CustomMethod
        );
      }
      AppsColorStoneLinksService.SaveGemStoneCustomMarkupdata(inputData, props.type)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          let msg = responseData.returnMessage;

          if (message === "Success") {
            if (
              msg ===
              "- Invalid Range. There is already a markup within given range."
            ) {
              NotificationManager.error(
                t(
                  "- Invalid Range. There is already a markup within given range."
                )
              );
            } else {
              NotificationManager.success(
                t("Custom Markup Saved Successfully.")
              );
              handleGetCustomerMineMarkupLoadData(
                DealerId,
                GemstoneData.CustomMethod,
                type
              );
            }
          } else {
            NotificationManager.error(t("Custom Markup Not Saved."));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }

    setIsEdit(false);
    setVisible(false);
    setDelMarkupData({});
    console.log("GemstoneData before set:", GemstoneData);
    setGemstoneData({
      ...GemstoneData,
      custommarkupid: 0,
      CertCl: "",
      CertClValue: "",
      CertClPercent: "",
      CustomInput1: "",
      CustomInput2: "",
      CustomInput3: "",
      GIA: false,
      AGS: false,
      EGL: false,
      IGI: false,
    });
  };

  // Delete Markup By Vendor Data

  const DeleteDealerMarkupData = () => {
    try {
      let inputData = {
        dealermarkupid: delMarkupData.dealermarkupid,
        dealerID: delMarkupData.dealerID,
      };

      AppsColorStoneLinksService.RemoveGemStoneDealerMarkupdata(inputData, props.type)
        .then((response) => {
          let message = response.data.message;

          if (message === "Success") {
            NotificationManager.success(
              t("Manufacturer Markup Removed Successfully.")
            );
            handleGetMakerMineMarkupLoadData(DealerId, props.type);
          } else {
            NotificationManager.error(t("Manufacturer Markup Not Removed."));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
    setVisible(false);
    setDelMarkupData({});
  };

  // delete customer Markup data
  const DeleteCustomerMarkupData = () => {
    try {
      let inputData = {
        customMarkupid: DelCutomerMarkupData.customMarkupid,
        dealerID: DelCutomerMarkupData.dealerID,
      };

      AppsColorStoneLinksService.RemoveGemStoneCustomMarkupdata(inputData, props.type)
        .then((response) => {
          let message = response.data.message;

          if (message === "Success") {
            NotificationManager.success(
              t("Custom Markup Removed Successfully.")
            );

            handleGetCustomerMineMarkupLoadData(
              DealerId,
              GemstoneData.CustomMethod,
              type
            );
            setGemstoneData({
              ...GemstoneData,
              custommarkupid: 0,
              CertCl: "",
              CertClValue: "",
              CertClPercent: "",
              GIA: false,
              AGS: false,
              EGL: false,
              IGI: false,
            });
            setCheckBox("");
            setIsButtonDisable(false);
          } else {
            NotificationManager.error(t("Custom Markup Not Removed."));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
    setVisible1(false);
  };

  // Price and Size API Start
  const handleGetAllCostPriceAndSize = (id, type) => {
    try {
      let inputData = {
        dealerId: id,
        type: type,
      };
      setGetAllCostPriceAndSizeLoading(true);
      AppsColorStoneLinksService.GetAllCostPriceAndSize(inputData, props.type)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (props.type) {
              setCostPriceAndSize(responseData);
            } else {
              setCostPriceAndSize(responseData);
            }

            setGetAllCostPriceAndSizeLoading(false);
            setShowAllComponent(false);
          } else {
            setGetAllCostPriceAndSizeLoading(false);
            setShowAllComponent(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setGetAllCostPriceAndSizeLoading(false);
          setShowAllComponent(false);
        });
    } catch (error) {
      console.log(error);
      setGetAllCostPriceAndSizeLoading(false);
      setShowAllComponent(false);
    }
  };
  const handleUpdateAllCostPriceAndSize = () => {
    try {
      let inputData = costPriceAndSize;
      inputData.markUpMethod = page;
      inputData.dealerId = DealerId;
      inputData.CurrencyValue = GemstoneData.Currency + "";
      setSubmitLoading(true);
      AppsColorStoneLinksService.UpdateAllCostPriceAndSize(inputData, props.type)
        .then((response) => {
          let message = response.data.message;
          setSubmitLoading(false);
          if (message === "Success") {
            NotificationManager.success(
              t("Default Markup Updated Successfully")
            );
            const currencyType = selectCurrencyDropdowenList.filter(
              (item) => item.currencyId == GemstoneData.Currency
            )?.[0]?.currencyType;
            dispatch(setCurrency(currencyType));
            setIsButtonDisable(true);
            handleGetAllCostPriceAndSize(DealerId, page);
          } else {
            NotificationManager.error(t("Record Not Updated."));
          }
        })
        .catch((error) => {
          setSubmitLoading(false);
          console.log(error);
        });
    } catch (error) {
      setSubmitLoading(false);
      console.log(error);
    }
  };

  const UpdateMIneCustomMarkupdata = () => {
    let isValid = handleDefaultMarkupValidation();

    if (!isValid) {
      return false;
    }
    try {
      let inputData = {
        currentMarkup: GemstoneData.DefaultMarkupOld
          ? GemstoneData.DefaultMarkupOld
          : "",
        dealerId: DealerId,
        defaltmarkup: GemstoneData.DefaultMarkup,
        custommarkupmethod: GemstoneData.CustomMethod,
        Markupmethod: GemstoneData.Method,
        CurrencyValue: GemstoneData.Currency + "",
      };
      setSubmitLoading(true);
      AppsColorStoneLinksService.UpdateGemStoneCustomMarkupdata(inputData, props.type)
        .then((response) => {
          let message = response.data.message;
          setSubmitLoading(false);
          if (message === "Success") {
            NotificationManager.success(
              t("Default Markup Updated Successfully")
            );
            const currencyType = selectCurrencyDropdowenList.filter(
              (item) => item.currencyId == GemstoneData.Currency
            )?.[0]?.currencyType;
            dispatch(setCurrency(currencyType));
            handleGetMineMarkupLoadData(DealerId, type);
            setIsButtonDisable(true);
          } else {
            NotificationManager.error(t("Record Not Updated."));
          }
        })
        .catch((error) => {
          setSubmitLoading(false);
          console.log(error);
        });
    } catch (error) {
      setSubmitLoading(false);
      console.log(error);
    }
  };

  const handleUpdateButton = () => {
    if (page == "Custom") {
      UpdateMIneCustomMarkupdata();
    } else {
      handleUpdateAllCostPriceAndSize();
    }
  };

  const onKeyPressMinusEvent = (e) => {
    if (e.code == "Minus") {
      e.preventDefault();
    } else if (
      e.key === "/" ||
      e.key === "*" ||
      e.key === "-" ||
      e.key === "+"
    ) {
      e.preventDefault();
    }
  };
  const onKeyPressMinusEventPriceSize = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!new RegExp("[0-9]").test(keyValue)) event.preventDefault();
  };

  function handleCheckBoxChange(checkedValues) {
    setCheckBox(checkedValues.target.value);
  }
  return (
    <div className="form__fields markup__section">
      <Spin spinning={showAllComponent} style={{ height: "100vh" }}>
        {showAllComponent == false && (
          <>
            <div className="row ">
              <div className="col-md-12">
                <div className="heading__block">
                  <h4 className="workarea__heading mt-0 mb-3">
                    {props.type
                      ? t("Lab Grown Markup")
                      : t("Gemstone Markup")}
                  </h4>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-12">
                    <div className="markup__heading">
                      <h4> {t("General Settings")} </h4>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input__block">
                      <label> {t("Method")} </label>
                      <Select
                        className="border__grey"
                        showSearch
                        placeholder={t("Select Method")}
                        name="Method"
                        value={
                          GemstoneData.Method
                            ? GemstoneData.Method
                            : null
                        }
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        optionFilterProp="children"
                        onChange={(e) => handleOnChange(e, "select", "Method")}
                      >
                        {GemstoneData.Method == "Size" ? (
                          <>
                            <Option value="Size"> Size </Option>
                            {/* <Option value="Custom"> Custom </Option> */}
                            <Option value="Price"> Price </Option>
                          </>
                        ) : GemstoneData.Method == "Price" ? (
                          <>
                            <Option value="Price"> Price </Option>
                            {/* <Option value="Custom"> Custom </Option> */}
                            <Option value="Size"> Size </Option>
                          </>
                        ) : (
                          <>
                            {/* <Option value="Custom"> Custom </Option> */}
                            <Option value="Price"> Price </Option>
                            <Option value="Size"> Size </Option>
                          </>
                        )}
                      </Select>
                    </div>
                  </div>
                  <div className="col-md-4 mt-0">
                    <div className="input__block mb-0">
                      <label> {t("Select Currency")} </label>
                      <Select
                        className="border__grey"
                        showSearch
                        placeholder={t("Choose Any")}
                        name="Currency"
                        value={
                          GemstoneData.Currency
                            ? GemstoneData.Currency
                            : null
                        }
                        optionFilterProp="children"
                        onChange={(e) =>
                          handleOnChange(e, "select", "Currency")
                        }
                      >
                        <Option value=""> Select Currency </Option>
                        {selectCurrencyDropdowenList.map((item) => {
                          return (
                            <React.Fragment>
                              <Option value={item.currencyId}>
                                {item.currencyType}
                              </Option>
                            </React.Fragment>
                          );
                        })}
                      </Select>
                    </div>
                  </div>

                  {page == "Custom" ? (
                    <div className="col-md-4">
                      <div className="input__block">
                        <label> {t("Custom Method")} </label>
                        <Select
                          className="border__grey"
                          showSearch
                          placeholder={t("Select Custom Method")}
                          name="CustomMethod"
                          value={
                            GemstoneData.CustomMethod
                              ? GemstoneData.CustomMethod
                              : undefined
                          }
                          optionFilterProp="children"
                          onChange={(e) =>
                            handleOnChange(e, "select", "CustomMethod")
                          }
                        >
                          <Option value="0">{t("By Price")} </Option>
                          <Option value="1">{t("By Size")} </Option>
                          <Option value="2">{t("By Off%")} </Option>
                        </Select>
                      </div>
                    </div>
                  ) : null}
                </div>

                <div className="row ">
                  {page == "Custom" ? (
                    <div className="col-md-12">
                      <div className="heading__block markup__heading">
                        <h4 className="workarea__heading mt-0">
                          {" "}
                          {t("Default Markup")}{" "}
                        </h4>
                      </div>
                    </div>
                  ) : null}

                  <div className="col-md-4">
                    <div className="input__block d-flex align-items-center mb-0 position-relative">
                      {page == "Custom" ? (
                        <React.Fragment>
                          <input
                            type="number"
                            name="DefaultMarkup"
                            step="1"
                            min="0"
                            max="1000"
                            value={
                              GemstoneData.DefaultMarkup
                                ? GemstoneData.DefaultMarkup
                                : null
                            }
                            onChange={(e) => handleOnChange(e, "DefaultMarkup")}
                            onKeyPress={onKeyPressMinusEvent}
                          />
                          <label
                            style={{ top: "8px", right: "35px" }}
                            className="percent markup__symbol"
                          >
                            %
                          </label>
                        </React.Fragment>
                      ) : null}
                    </div>
                    {defaultMarkupValidation.DefaultMarkupVal && (
                      <p className="error-color-red">
                        {defaultMarkupValidation.DefaultMarkupVal}
                      </p>
                    )}
                  </div>
                  <div className="col-md-12">
                    <div className="input__block">
                      <label className="mt-2">
                        {t(
                          "In order to protect the integrity of the Gem Stone and the jewelry industry, the minimum mark up on the Gem Stone link should be no less than 7%"
                        )}
                      </label>
                    </div>
                  </div>
                </div>

                {page == "Custom" ? (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="heading__block markup__heading">
                        <h4 class="workarea__heading mt-0">
                          {t("Markup By Vendor")}
                        </h4>
                      </div>

                      <div className="row markupinputrow">
                        <div className="col-md-4 col-6">
                          <div className="input__block">
                            <Select
                              className="border__grey"
                              showSearch
                              placeholder={t("Select Manufacturer")}
                              name="SelectManufacturer"
                              value={
                                GemstoneData.SelectManufacturer
                                  ? GemstoneData.SelectManufacturer
                                  : []
                              }
                              optionFilterProp="children"
                              onChange={(e) =>
                                handleOnChange(
                                  e,
                                  "select",
                                  "SelectManufacturer"
                                )
                              }
                            >
                              <Option>{t("Select Manufacturer")}</Option>
                              {manufactureList &&
                                manufactureList.map((item, i) => {
                                  return (
                                    <Option value={item.dealerid}>
                                      {item.dealertitle +
                                        " " +
                                        "(" +
                                        item.dealerid +
                                        ")"}
                                    </Option>
                                  );
                                })}
                            </Select>
                            <div>
                              {validations.SelectManufacturerVal && (
                                <p className="error-color-red">
                                  {validations.SelectManufacturerVal}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4 col-6">
                          <div className="input__block position-relative">
                            <input
                              type="text"
                              name="MarkupPercent"
                              value={GemstoneData.MarkupPercent || ""}
                              onChange={(e) => {
                                handleOnChange(e, "MarkupPercent");
                              }}
                              onKeyPress={onKeyPressMinusEvent}
                            />
                            <label class="percent">%</label>
                            <div>
                              {validations.MarkupPercentVal && (
                                <p className="error-color-red mt-2">
                                  {validations.MarkupPercentVal}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4 col-6">
                          <div className="input__block">
                            <button
                              className="primary-btn ml-2 mobile-m-0"
                              onClick={handleAddDealerMarkupdata}
                            >
                              {t("Add")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 divForm">
                      <Spin spinning={makerLoading} size="large">
                        <div className="table__scroll mb-3">
                          <Table
                            columns={[
                              {
                                title: (
                                  <Tooltip title={t("ID")}>{t("ID")}</Tooltip>
                                ),
                                ellipsis: true,
                                showSorterTooltip: false,
                                dataIndex: "manufacturerid",
                                sorter: (a, b) =>
                                  a.manufacturerid - b.manufacturerid,
                              },
                              {
                                title: (
                                  <Tooltip title={t("Dealers")}>
                                    {t("Dealers")}
                                  </Tooltip>
                                ),
                                ellipsis: true,
                                showSorterTooltip: false,
                                dataIndex: "manufacturercompany",
                                sorter: (a, b) =>
                                  a.manufacturercompany.localeCompare(
                                    b.manufacturercompany
                                  ),
                              },
                              {
                                title: (
                                  <Tooltip title={t("Markup")}>
                                    {t("Markup")}
                                  </Tooltip>
                                ),
                                ellipsis: true,
                                showSorterTooltip: false,
                                dataIndex: "markup",
                                sorter: (a, b) => a.markup - b.markup,
                                render: (index, row) => {
                                  return <span>{row.markup}%</span>;
                                },
                              },

                              {
                                title: "",
                                // fixed: "right",
                                render: (index, row) => (
                                  <div className="action__btns">
                                    <div
                                      className="image__block"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                      }}
                                    >
                                      <img
                                        src={Delete_iconbl}
                                        alt=""
                                        onClick={() => {
                                          handleDeleteData(row);
                                        }}
                                      />
                                    </div>
                                  </div>
                                ),
                              },
                            ]}
                            dataSource={markedUpDealersList}
                            pagination={{
                              size: "small",
                              showSizeChanger: true,
                              responsive: true,
                            }}
                          />
                        </div>
                      </Spin>
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="col-md-6">
                {page == "Custom" ? (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="heading__block markup__heading">
                        <h4 className="workarea__heading mt-0">
                          {GemstoneData.CustomMethod === "0"
                            ? t("Markup By Price Range With Certs")
                            : GemstoneData.CustomMethod === "2"
                            ? t("Markup By Off% Range")
                            : t("Markup By Size Range With Certs")}
                        </h4>
                      </div>

                      <div className="row markupinputrow">
                        {GemstoneData.CustomMethod === "2" ? (
                          <Fragment>
                            <div className="col-md-3 col-6 mobile__bottomspace">
                              <div className="input__block d-flex align-items-center mb-0 position-relative">
                                <input
                                  type="text"
                                  name="CustomInput1"
                                  placeholder={t("Min Off %")}
                                  className="left__markup"
                                  value={GemstoneData.CustomInput1 || ""}
                                  onChange={(e) =>
                                    handleOnChange(e, "CustomInput1")
                                  }
                                  onKeyPress={onKeyPressMinusEvent}
                                />
                              </div>
                            </div>

                            <div className="col-md-3 col-6 mobile__bottomspace">
                              <div className="input__block d-flex align-items-center mb-0 position-relative">
                                <input
                                  type="text"
                                  name="CustomInput2"
                                  placeholder={t("Max Off %")}
                                  className="left__markup"
                                  value={GemstoneData.CustomInput2 || ""}
                                  onChange={(e) =>
                                    handleOnChange(e, "CustomInput2")
                                  }
                                  onKeyPress={onKeyPressMinusEvent}
                                />
                              </div>
                            </div>

                            <div className="col-md-3 col-6 mobile__bottomspace">
                              <div className="input__block d-flex align-items-center mb-0 position-relative">
                                <input
                                  type="text"
                                  name="CustomInput3"
                                  placeholder={t("Markup %")}
                                  className="left__markup"
                                  value={GemstoneData.CustomInput3 || ""}
                                  onChange={(e) =>
                                    handleOnChange(e, "CustomInput3")
                                  }
                                  onKeyPress={onKeyPressMinusEvent}
                                />
                              </div>
                            </div>
                          </Fragment>
                        ) : (
                          <>
                            <div className="col-md-3 col-6 mobile__bottomspace">
                              <div className="input__block d-flex align-items-center mb-0 position-relative">
                                {GemstoneData.CustomMethod == "0" ? (
                                  <label className="markup__symbol">
                                    {currencySymbol}
                                  </label>
                                ) : null}
                                <input
                                  type="text"
                                  name="CertCl"
                                  placeholder={
                                    GemstoneData.CustomMethod == "0"
                                      ? t("Min Price")
                                      : t("Min Size")
                                  }
                                  value={GemstoneData.CertCl || ""}
                                  onChange={(e) => {
                                    e.target.value = e.target.value.slice(
                                      0,
                                      10
                                    );
                                    handleOnChange(e, "CertCl");
                                  }}
                                  onKeyPress={onKeyPressMinusEvent}
                                />
                                {GemstoneData.CustomMethod == "1" ? (
                                  <label className="ml-2"> {t("Ct.")} </label>
                                ) : null}
                              </div>
                              {validations1.CertClVal && (
                                <p className="error-color-red">
                                  {validations1.CertClVal}
                                </p>
                              )}
                            </div>

                            <div className="col-md-3 col-6 mobile__bottomspace">
                              <div className="input__block d-flex align-items-center mb-0 position-relative">
                                {GemstoneData.CustomMethod == "0" ? (
                                  <label className="markup__symbol">
                                    {currencySymbol}
                                  </label>
                                ) : null}

                                <input
                                  type="text"
                                  name="CertClValue"
                                  placeholder={
                                    GemstoneData.CustomMethod == "0"
                                      ? t("Max Price")
                                      : t("Max Size")
                                  }
                                  value={GemstoneData.CertClValue || ""}
                                  onChange={(e) => {
                                    e.target.value = e.target.value.slice(
                                      0,
                                      10
                                    );
                                    handleOnChange(e, "CertClValue");
                                  }}
                                  onKeyPress={onKeyPressMinusEvent}
                                />
                                {GemstoneData.CustomMethod == "1" ? (
                                  <label className="ml-2"> {t("Ct.")} </label>
                                ) : null}
                              </div>
                              {validations1.CertClValueVal && (
                                <p className="error-color-red">
                                  {validations1.CertClValueVal}
                                </p>
                              )}
                            </div>

                            <div className="col-md-3 col-6 mobile__bottomspace">
                              <div className="input__block d-flex align-items-center mb-0 position-relative">
                                <input
                                  type="text"
                                  name="CertClPercent"
                                  placeholder={t("MarkUP")}
                                  className="left__markup"
                                  value={GemstoneData.CertClPercent || ""}
                                  step="0.01"
                                  min="0"
                                  max="100"
                                  onChange={(e) =>
                                    handleOnChange(e, "CertClPercent")
                                  }
                                  onKeyPress={onKeyPressMinusEvent}
                                />
                                <label className="percent">%</label>
                              </div>
                              {validations1.CertClPercentVal && (
                                <p className="error-color-red">
                                  {validations1.CertClPercentVal}
                                </p>
                              )}
                            </div>
                          </>
                        )}
                        <div className="col-md-1 col-6 mobile__bottomspace">
                          <div className="input__block d-flex mb-0">
                            <button
                              className="primary-btn ml-2 mobile-m-0"
                              onClick={() => handleSaveCustomMarkupdata()}
                            >
                              {t("Add")}
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12">
                          <div className="row mt-3 mb-3 markup__checkbkox">
                            {!isedit &&
                            GemstoneData.CustomMethod !== "2" ? (
                              <Fragment>
                                <div className="col-md-2 col-6 checkbox__block">
                                  <Checkbox
                                    type="checkbox"
                                    className="mr-1"
                                    id="MarkupGIA"
                                    name="GIA"
                                    value={GemstoneData.GIA}
                                    checked={GemstoneData.GIA}
                                    onChange={(e) =>
                                      handleOnChangeRadio(e, "GIA")
                                    }
                                  >
                                    <label htmlFor="MarkupGIA">
                                      {" "}
                                      {t("GIA")}{" "}
                                    </label>
                                  </Checkbox>
                                </div>

                                <div className="col-md-2 col-6 checkbox__block">
                                  <Checkbox
                                    type="checkbox"
                                    className="mr-1"
                                    id="MarkupAGS"
                                    name="AGS"
                                    value={GemstoneData.AGS}
                                    checked={GemstoneData.AGS}
                                    onChange={(e) =>
                                      handleOnChangeRadio(e, "AGS")
                                    }
                                  >
                                    <label htmlFor="MarkupAGS">
                                      {" "}
                                      {t("AGS")}{" "}
                                    </label>
                                  </Checkbox>
                                </div>

                                <div className="col-md-2 col-6 checkbox__block">
                                  <Checkbox
                                    className="mr-1"
                                    id="MarkupEGL"
                                    name="EGL"
                                    value={GemstoneData.EGL}
                                    checked={GemstoneData.EGL}
                                    onChange={(e) =>
                                      handleOnChangeRadio(e, "EGL")
                                    }
                                  >
                                    <label htmlFor="MarkupEGL">
                                      {" "}
                                      {t("EGL")}{" "}
                                    </label>
                                  </Checkbox>
                                </div>

                                <div className="col-md-2 col-6 checkbox__block">
                                  <Checkbox
                                    className="mr-1"
                                    id="MarkupIGI"
                                    name="IGI"
                                    value={GemstoneData.IGI}
                                    checked={GemstoneData.IGI}
                                    onChange={(e) =>
                                      handleOnChangeRadio(e, "IGI")
                                    }
                                  >
                                    <label htmlFor="MarkupIGI">
                                      {" "}
                                      {t("IGI")}{" "}
                                    </label>
                                  </Checkbox>
                                </div>
                              </Fragment>
                            ) : !isedit &&
                              GemstoneData.CustomMethod === "2" ? null : (
                              <div className="d-flex">
                                {category.map((item) => {
                                  return (
                                    <Fragment>
                                      <div
                                        className={
                                          item.value == "GIA"
                                            ? "radio__block"
                                            : "radio__block mx-5"
                                        }
                                      >
                                        <Checkbox
                                          key={item.value}
                                          onChange={handleCheckBoxChange}
                                          checked={item.value == checkbox}
                                          value={item.value}
                                          id={item.value}
                                        >
                                          <label htmlFor={item.value}>
                                            {" "}
                                            {t(item.label)}{" "}
                                          </label>
                                        </Checkbox>
                                      </div>
                                    </Fragment>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 divForm">
                      <div className="table__scroll mb-3">
                        <Table
                          columns={
                            GemstoneData.CustomMethod === "2"
                              ? [
                                  {
                                    title: (
                                      <Tooltip title={t("Min Off")}>
                                        {t("Min Off")}
                                      </Tooltip>
                                    ),
                                    ellipsis: true,
                                    dataIndex: "CustomInput1Val",
                                    sorter: (a, b) =>
                                      a.CustomInput1Val - b.CustomInput1Val,
                                    render: (item, row) => (
                                      <span>{row.CustomInput1Val}</span>
                                    ),
                                  },
                                  {
                                    title: (
                                      <Tooltip title={t("Max Off")}>
                                        {t("Max Off")}
                                      </Tooltip>
                                    ),
                                    ellipsis: true,
                                    dataIndex: "CustomInput2Val",
                                    sorter: (a, b) =>
                                      a.CustomInput2Val - b.CustomInput2Val,
                                    render: (item, row) => (
                                      <span>{row.CustomInput2Val}</span>
                                    ),
                                  },
                                  {
                                    title: (
                                      <Tooltip title={t("Markup")}>
                                        {t("Markup")}
                                      </Tooltip>
                                    ),
                                    ellipsis: true,
                                    dataIndex: "CustomInput3Val",
                                    sorter: (a, b) =>
                                      a.CustomInput3Val - b.CustomInput3Val,
                                    render: (item, row) => (
                                      <span>{row.CustomInput3Val}%</span>
                                    ),
                                  },
                                  {
                                    title: "",
                                    render: (index, row) => (
                                      <div className="action__btns">
                                        <div
                                          className="image__block"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                          }}
                                        >
                                          <img
                                            src={Delete_iconbl}
                                            alt=""
                                            onClick={() => {
                                              handleDeleteCustomerMarkupData(
                                                row
                                              );
                                            }}
                                          />
                                        </div>
                                      </div>
                                    ),
                                  },
                                ]
                              : [
                                  {
                                    title: (
                                      <Tooltip
                                        title={
                                          GemstoneData.CustomMethod === "0"
                                            ? t("Min Price")
                                            : t("Min Size")
                                        }
                                      >
                                        {GemstoneData.CustomMethod === "0"
                                          ? t("Min Price")
                                          : t("Min Size")}
                                      </Tooltip>
                                    ),
                                    dataIndex: "minrange",
                                    sorter: (a, b) => a.minrange - b.minrange,
                                    showSorterTooltip: false,
                                    render: (item, row) => (
                                      <span>
                                        {GemstoneData.CustomMethod === "0"
                                          ? currencySymbol + " " + row.minrange
                                          : row.minrange}
                                      </span>
                                    ),
                                  },
                                  {
                                    title: (
                                      <Tooltip
                                        title={
                                          GemstoneData.CustomMethod === "0"
                                            ? t("Max Price")
                                            : t("Max Size")
                                        }
                                      >
                                        {GemstoneData.CustomMethod === "0"
                                          ? t("Max Price")
                                          : t("Max Size")}
                                      </Tooltip>
                                    ),
                                    dataIndex: "maxrange",
                                    showSorterTooltip: false,
                                    sorter: (a, b) => a.maxrange - b.maxrange,
                                    render: (item, row) => (
                                      <span>
                                        {GemstoneData.CustomMethod === "0"
                                          ? currencySymbol + " " + row.maxrange
                                          : row.maxrange}
                                      </span>
                                    ),
                                  },
                                  {
                                    title: (
                                      <Tooltip title={t("Certificate")}>
                                        {t("Cert.")}
                                      </Tooltip>
                                    ),
                                    ellipsis: true,
                                    showSorterTooltip: false,
                                    dataIndex: "certificate",
                                    sorter: (a, b) =>
                                      a.certificate.localeCompare(
                                        b.certificate
                                      ),
                                  },
                                  {
                                    title: (
                                      <Tooltip title={t("Markup")}>
                                        {t("Markup")}
                                      </Tooltip>
                                    ),
                                    ellipsis: true,
                                    showSorterTooltip: false,
                                    dataIndex: "markup",
                                    sorter: (a, b) => a.markup - b.markup,
                                    render: (index, row) => (
                                      <span>{row.markup}%</span>
                                    ),
                                  },
                                  {
                                    title: "",
                                    render: (index, row) => (
                                      <div className="action__btns">
                                        <div
                                          className="image__block"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                          }}
                                        >
                                          <img
                                            src={Delete_iconbl}
                                            alt=""
                                            onClick={() => {
                                              handleDeleteCustomerMarkupData(
                                                row
                                              );
                                            }}
                                          />
                                        </div>
                                      </div>
                                    ),
                                  },
                                ]
                          }
                          dataSource={customMarkUpsList}
                          loading={customerLoading}
                          pagination={{
                            size: "small",
                            showSizeChanger: true,
                            responsive: true,
                          }}
                          onRow={(record, recordIndex) => ({
                            onClick: (event) => {
                              setIsEdit(true);
                              setGemstoneData({
                                ...GemstoneData,
                                custommarkupid: record.custommarkupid,
                                CertCl:
                                  GemstoneData.CustomMethod === "2"
                                    ? record.CustomInput1Val
                                    : record.minrange,
                                CertClValue:
                                  GemstoneData.CustomMethod === "2"
                                    ? record.CustomInput2Val
                                    : record.maxrange,
                                CertClPercent:
                                  GemstoneData.CustomMethod === "2"
                                    ? record.CustomInput3Val
                                    : record.markup,
                              });
                              setCheckBox(record.certificate);
                            },
                          })}
                        />
                      </div>
                    </div>

                    <Modal
                      title=""
                      className="modalconsupld__section"
                      centered
                      visible={visible}
                      onOk={() => setVisible(false)}
                      onCancel={() => setVisible(false)}
                      width={400}
                      footer={[
                        <Button key="back" onClick={handleCancel}>
                          {t("Cancel")}
                        </Button>,
                        <Button
                          key="submit"
                          type="primary"
                          onClick={DeleteDealerMarkupData}
                        >
                          {t("Delete")}
                        </Button>,
                      ]}
                    >
                      <div className="col-lg-12">
                        <div className="modal__body">
                          <div className="col-lg-12">
                            <div className="form__fields border-0 p-0">
                              <div className="row">
                                <div className="col-lg-12 mt-4 text-center">
                                  <p>
                                    {t(
                                      "Are You Sure You Want To Delete This Markup ?"
                                    )}
                                  </p>
                                  <h5>{t("THIS CAN NOT BE UNDONE")}</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Modal>

                    <Modal
                      title=""
                      className="modalconsupld__section"
                      centered
                      visible={visible1}
                      onOk={() => setVisible1(false)}
                      onCancel={() => setVisible1(false)}
                      width={400}
                      footer={[
                        <Button key="back" onClick={handleCancel1}>
                          {t("Cancel")}
                        </Button>,
                        <Button
                          key="submit"
                          type="primary"
                          onClick={DeleteCustomerMarkupData}
                        >
                          {t("Delete")}
                        </Button>,
                      ]}
                    >
                      <div className="col-lg-12">
                        <div className="modal__body">
                          <div className="col-lg-12">
                            <div className="form__fields border-0 p-0">
                              <div className="row">
                                <div className="col-lg-12 mt-4 text-center">
                                  <p>
                                    {t(
                                      "Are You Sure You Want To Delete This Markup ?"
                                    )}
                                  </p>
                                  <h5>{t("THIS CAN NOT BE UNDONE")}</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Modal>
                  </div>
                ) : null}

                {/* By Price && By Size */}

                {page == "Price" || page == "Size" ? (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="heading__block markup__heading">
                        <h4 className="workarea__heading mt-0">
                          {page == "Price" ? (
                            <> {t("Markup By Price Range")} </>
                          ) : (
                            <> {t("Markup By Size Range")} </>
                          )}
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-12 divForm">
                      <Spin
                        spinning={getAllCostPriceAndSizeLoading}
                        size="large"
                      >
                        {page == "Price" ? (
                          <div className="table__scroll mb-3">
                            <Table
                              key={minMaxMarkupPrice}
                              columns={[
                                {
                                  title: (
                                    <Tooltip title={t("Min Price")}>
                                      {t("Min Price")}
                                    </Tooltip>
                                  ),
                                  ellipsis: true,
                                  showSorterTooltip: false,
                                  dataIndex: "min",
                                  render: (index, row) => {
                                    return (
                                      <span>
                                        {row.min === "50000.01" ? (
                                          <span>
                                            Above {currencySymbol} {row.min}
                                          </span>
                                        ) : (
                                          <span>
                                            {currencySymbol + " " + row.min}
                                          </span>
                                        )}
                                      </span>
                                    );
                                  },
                                },
                                {
                                  title: (
                                    <Tooltip title={t("Max Price")}>
                                      {t("Max Price")}
                                    </Tooltip>
                                  ),
                                  ellipsis: true,
                                  showSorterTooltip: false,
                                  dataIndex: "max",
                                  render: (index, row) => {
                                    return (
                                      <span>
                                        {row.max ? currencySymbol : ""}{" "}
                                        {row.max}
                                      </span>
                                    );
                                  },
                                },
                                {
                                  title: (
                                    <Tooltip title={t("Markup")}>
                                      {t("Markup")}
                                    </Tooltip>
                                  ),
                                  ellipsis: true,
                                  render: (item, row) => (
                                    <div className="markupinputrow">
                                      <div className="col-md-6">
                                        <div className="input__block d-flex align-items-center mb-0">
                                          <input
                                            type="text"
                                            onKeyPress={
                                              onKeyPressMinusEventPriceSize
                                            }
                                            value={costPriceAndSize[row.Markup]}
                                            onChange={handleTableOnchange}
                                            name={row.Markup}
                                          />

                                          <span className="percent"> %</span>
                                        </div>
                                      </div>
                                    </div>
                                  ),
                                },
                              ]}
                              dataSource={minMaxMarkupPrice}
                              pagination={{
                                size: "small",
                                showSizeChanger: true,
                                responsive: true,
                              }}
                            />
                          </div>
                        ) : null}
                        {page == "Size" ? (
                          <div className="table__scroll mb-3">
                            <Table
                              columns={[
                                {
                                  title: (
                                    <Tooltip title={t("Min Size")}>
                                      {t("Min Size")}
                                    </Tooltip>
                                  ),
                                  ellipsis: true,
                                  dataIndex: "min",
                                  render: (item, row) => {
                                    return (
                                      <div>
                                        <span>
                                          {row.min == "6.00ct"
                                            ? "6.00ct and larger"
                                            : row.min}
                                        </span>
                                      </div>
                                    );
                                  },
                                },
                                {
                                  title: (
                                    <Tooltip title={t("Max Size")}>
                                      {t("Max Size")}
                                    </Tooltip>
                                  ),
                                  ellipsis: true,
                                  dataIndex: "max",
                                },
                                {
                                  title: (
                                    <Tooltip title={t("Markup")}>
                                      {t("Markup")}
                                    </Tooltip>
                                  ),
                                  ellipsis: true,
                                  render: (item, row) => (
                                    <div className="markupinputrow">
                                      <div className="col-md-6">
                                        <div className="input__block d-flex align-items-center mb-0">
                                          <input
                                            type="text"
                                            onKeyPress={
                                              onKeyPressMinusEventPriceSize
                                            }
                                            value={costPriceAndSize[row.Markup]}
                                            onChange={handleTableOnchange}
                                            name={row.Markup}
                                          />

                                          <span className="percent"> %</span>
                                        </div>
                                      </div>
                                    </div>
                                  ),
                                },
                              ]}
                              dataSource={minMaxSize}
                              pagination={{
                                size: "small",
                                showSizeChanger: true,
                                responsive: true,
                              }}
                            />
                          </div>
                        ) : null}
                      </Spin>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>

            <div className="col-md-2">
              <div className="input__block mt-3">
                <Button
                  className={
                    isButtonDisable
                      ? "disabled-btn "
                      : "primary-btn ml-2 mobile-m-0"
                  }
                  disabled={isButtonDisable}
                  onClick={handleUpdateButton}
                  loading={submitLoading}
                >
                  {" "}
                  {t("Update Markup")}{" "}
                </Button>
              </div>
            </div>
          </>
        )}
      </Spin>
    </div>
  );
};

export default GemStoneMarkup;
